import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const inventoryPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [{ label: 'Inicio', onClick: () => navigate('/') }];
export const childrenInventoryPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...inventoryPageBreadcrumbs(navigate),
  { label: 'Inventario', onClick: () => navigate('/inventory') },
];

export const locationsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenInventoryPageBreadcrumbs(navigate),
];
